<!--照明管理界面-->
<template>
	<treeBody>
		<datePicker ref="datePicker" :initDate='nowSelectDate' @selectDate="selectDate" type="day"></datePicker>
		<virtualDeviceTree slot="tree" :dataList="virtualDeviceList" @checkItem="$store.deviceStore.commit('setNowVirtualDevice',$event)"></virtualDeviceTree>
		<div slot="body" style="overflow-y: auto;" class="custom-scrollbar">
			<div class="flexBetween" style="margin: 10px 10px 10px 0;">
				<div class="archivesBox">
					<!-- 台账信息 -->
					<div v-for="item in nowTypePropertyList" class="flexBetween" style="margin-bottom: 8px;">
						<span class="filterP">{{item.propertyName}}</span>
						<input style="width: 300px;" v-if="item.typePropertyCode != 'installLocation'" type="text" :value="nowVirtualDevice[nowVirtualDevice.archivesTypeCode+'___'+item.typePropertyCode] == undefined?'':nowVirtualDevice[nowVirtualDevice.archivesTypeCode+'___'+item.typePropertyCode]">
						<textarea style="height: 50px;width: 300px;resize: none;" class="custom-scrollbar" v-else :value="nowVirtualDevice[nowVirtualDevice.archivesTypeCode+'___'+item.typePropertyCode] == undefined?'':nowVirtualDevice[nowVirtualDevice.archivesTypeCode+'___'+item.typePropertyCode]"></textarea>
					</div>
				</div>
				<div class="controlBox flexBetween">
					<!-- 遥控及统计、二维码 -->
					<div class="flexCenterColumn">
						<p class="filterP flexBetween">当前状态 : <span>{{openStateText}}</span> </p>
						<p class="filterP flexBetween">总使用时长(小时): <span>{{useTimeText}}</span> </p>
						<p class="filterP flexBetween">需要更换: <span>{{needReplace}}</span> </p>
						<img :src="lightControlImg" :title="controlTips" @click="control">
					</div>
					<div class="flexCenterColumn">
						<div id="qrcode" style="width: 100px;height: 100px;"></div>
						<p style="margin-top: 10px;" v-if="showQRCodeText">设备二维码(仅用于App)</p>
					</div>
				</div>
			</div>
			<div class="chartBox">
				<!-- 日月运行曲线 -->
				<iconButton icoName="wedoButton/date.png" style="width: 80px;" :buttonText="nowDateText" @buttonClick="$refs.datePicker.show()"></iconButton>
				<vchart style="height: 250px;" ref='dayChart'></vchart>
				<vchart style="height: 250px;margin-top:20px ;" ref='monthChart'></vchart>
			</div>
		</div>
	</treeBody>
</template>

<script>
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import virtualDeviceTree from '@/components/module/tree/virtualDeviceTree.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import datePicker from '@/components/module/universal/datePicker.vue'
	export default {
		components: {
			treeBody,
			virtualDeviceTree,
			vchart,
			iconButton,
			datePicker,
		},
		props: {},
		data() {
			return {
				useTime: undefined,
				dayOptions: {},
				monthOptions: {},
				lastMonth: undefined,
				baseDeviceTree: undefined,
				showQRCodeText: false
			}
		},
		created() {},
		mounted() {
			debugPage = this
			this.createQRCode(this.nowVirtualDevice)
			//初始化图表
			this.dayOptions = this.$refs.dayChart.getDefaultOptions()
			this.dayOptions.title.text = '日开关记录'
			this.dayOptions.xAxis.type = 'time'
			this.dayOptions.legend.show = false
			this.dayOptions.tooltip.formatter = (params, ticket, callback) => {
				var label = new Date(params[0].data[0]).formatByTime() + "</br>"
				params.forEach(item => {
					var values;
					if (isnull(item.data[1])) {
						values = "无采集数据";
					} else {
						values = item.data[1] == 1 ? '开' : '关'
					}
					label += item.seriesName + " : " + values + "</br>"
				})
				return label;
			}
			this.dayOptions.grid.bottom = 0
			this.$refs.dayChart.setData(this.dayOptions, true)
			this.monthOptions = this.$refs.monthChart.getDefaultOptions()
			this.monthOptions.title.text = '每日开启时长(小时)'
			this.monthOptions.legend.show = false
			this.monthOptions.grid.bottom = 0
			this.$refs.monthChart.setData(this.monthOptions, true)
			//获取具备照明变量的虚拟设备树
			this.$dialogMethod.showLoading('正在加载照明设备。。。')
			this.$api.deviceApi.getReadDeviceTree(undefined, 276, respon => {
				this.baseDeviceTree = respon
				this.$dialogMethod.closeLoading()
			})
		},
		destroyed() {
			this.realTimeValueStore.commit("removeKeys", [getValueIfNoNull(this.nowLightVariable, {}).fromName])
		},
		computed: {
			realTimeValueStore() {
				return this.$store.realTimeValueStore
			},
			nowSelectDate() {
				return this.$store.cacheStore.getters.getNowSelectDate
			},
			nowDateText() {
				return this.nowSelectDate.formatByDate('-')
			},
			virtualDeviceList() {
				//经过过滤的，
				if (isempty(this.baseDeviceTree)) {
					return []
				}
				return [this.baseDeviceTree]
			},
			nowVirtualDevice() {
				//当前选中的虚拟设备，同时会查询对应台账设备信息附在里面
				if (this.$store.deviceStore.state.nowVirtualDevice == undefined) {
					return {}
				}
				var device = copy(this.$store.deviceStore.state.nowVirtualDevice)
				if (!isempty(device)) {
					device = this.addArchivesListInfo(device)
				}
				return device
			},
			variableTree() {
				if (this.nowVirtualDevice == undefined) {
					return []
				}
				return this.$store.variableStore.getters.getVariableTree(this.nowVirtualDevice.no)
			},
			nowLightVariable() {
				//用于判断灯开关状态的变量
				for (var i = 0, len = this.variableTree.length; i < len; i++) {
					var item = this.variableTree[i]
					var variable = item.next.find(it => it.typeNo == 276)
					if (variable != undefined) {
						return variable
					}
				}
				return
			},
			nowLightControlVariable() {
				//用于开关灯状态的变量
				for (var i = 0, len = this.variableTree.length; i < len; i++) {
					var item = this.variableTree[i]
					var variable = item.next.find(it => it.typeNo == 276)
					if (variable != undefined) {
						return variable
					}
				}
				return
			},
			nowTypePropertyList() {
				//当前选中类型的属性列表
				if (this.nowVirtualDevice == undefined) {
					return []
				}
				return this.$store.archivesStore.getters.getPropertyByTypeCode('lightDevice')
			},
			needReplace() {
				if (this.useTime == undefined) {
					return '--'
				}
				//提醒更换的使用时长
				var warnTime = parseFloat(getValueIfNoNull(this.nowVirtualDevice.lightDevice___warnTime, 30000)) * 60 * 60 * 1000
				return this.useTime > parseFloat(warnTime) ? '是' : '否'
			},
			useTimeText() {
				if (!this.useTime) {
					return '--'
				}
				return cutDigital(this.useTime / 3600000, 1)
			},
			openState() {
				//当前灯具开关状态
				if (this.nowLightVariable == undefined) {
					return
				}
				var vl = this.realTimeValueStore.getters.getValue([this.nowLightVariable.fromName])
				if (!isempty(vl)) {
					return parseFloat(vl[0]) > 0.1 ? 1 : 0
				}
				return
			},
			openStateText() {
				switch (this.openState) {
					case 0:
						return '关'
					case 1:
						return '开'
					default:
						return '--'
				}
			},
			controlTips() {
				switch (this.openState) {
					case 0:
						return '开灯'
					case 1:
						return '关灯'
					default:
						return '当前无法遥控'
				}
			},
			lightControlImg() {
				switch (this.openState) {
					case 0:
						return this.$store.resourcesStore.getters.getResourcesByName('light/light_off.png')
					case 1:
						return this.$store.resourcesStore.getters.getResourcesByName('light/light_on.png')
					default:
						return this.$store.resourcesStore.getters.getResourcesByName('light/light_disable.png')
				}
			}
		},
		watch: {
			nowVirtualDevice(nv, ov) {
				this.createQRCode(nv)
			},
			needReplace(nv, ov) {
				this.getUseTime()
			},
			nowLightVariable(nv, ov) {
				//获取当前开关状态
				if (ov != undefined) {
					this.realTimeValueStore.commit("removeKeys", [ov.fromName])
				}
				if (nv != undefined) {
					this.realTimeValueStore.commit("addKeys", [nv.fromName])
					this.getUseTime()
					this.getCurve()
				}
			},
			nowSelectDate() {
				this.getCurve()
			}
		},
		methods: {
			selectDate(date) {
				this.$store.cacheStore.commit("setNowSelectDate", date)
				this.$refs.datePicker.hide()
			},
			addArchivesListInfo(item) {
				if (!item.hasOwnProperty('archivesId')) {
					return item
				}
				//增加属性值
				this.$store.archivesStore.getters.getArchivesInfoById(item.archivesId).forEach(it => {
					if (it.valueType == 7) {
						//如果是枚举,先找枚举列表
						var enumList = this.$store.enumStore.getters.getEnumByEnumCode(it.enumCode)
						if (!isempty(enumList.next)) {
							var Enum = enumList.next.find(e => {
								return e.pkid == it.value
							})
							item[it.typeCode + "___" + it.propertyCode] = Enum == undefined ? '' : Enum.itemText
						}
					} else {
						if (it.valueType == 6) {
							item[it.typeCode + "___" + it.propertyCode] = it.value == 1 ? "是" : "否"
						} else {
							item[it.typeCode + "___" + it.propertyCode] = it.value
						}
					}
				})
				return item
			},
			createQRCode(nowVirtualDevice) {
				if (isempty(nowVirtualDevice) || !nowVirtualDevice.hasOwnProperty('archivesId')) {
					document.getElementById("qrcode").innerHTML = "";
					this.showQRCodeText = false
					return
				}
				let info = {}
				info.pkid = nowVirtualDevice.archivesId
				info['pfid'] = ''
				eachObject(nowVirtualDevice, (value, key) => {
					if (key.includes('___pfid')) {
						info.pfid = getValueIfNoNull(value, '')
					}
				})
				document.getElementById("qrcode").innerHTML = "";
				new QRCode('qrcode', {
					width: 100,
					height: 100,
					text: JSON.stringify(info)
				})
				this.showQRCodeText = true
			},
			getUseTime() {
				if (isempty(this.nowVirtualDevice) || isempty(this.nowVirtualDevice.lightDevice___installTime) || isempty(this.nowLightVariable)) {
					this.useTime = undefined
					return
				}
				//开始时间
				var bg = new Date(this.nowVirtualDevice.lightDevice___installTime).getTime()
				var end = Date.now()
				this.$api.lightOldApi.getLightingRangeTime(this.nowLightVariable.fromName, bg, end, respon => {
					if (!isempty(respon) && respon.hasOwnProperty(this.nowLightVariable.fromName)) {
						this.useTime = respon[this.nowLightVariable.fromName]
					}
				})
			},
			getCurve() {
				if (isempty(this.nowVirtualDevice) || isempty(this.nowLightVariable)) {
					return
				}
				//查询指定日期的开关记录
				var dayBg = new Date(this.nowSelectDate.formatByDate()).getTime()
				this.$api.lightOldApi.getLightingRangeList(this.nowLightVariable
					.fromName, dayBg, dayBg + 24 * 60 * 60 * 1000, respon => {
						var result = []
						if (respon != undefined) {
							var dataList = respon[this.nowLightVariable.fromName]
							var timeList = []
							var startTag = undefined
							for (var i = 0, len = dataList.length; i < len; i++) {
								var item = dataList[i]
								if (item[0] == undefined) {
									if (startTag == undefined) {
										startTag = 1
									}
								} else {
									if (startTag == undefined) {
										startTag = 0
									}
									timeList.push(item[0])
								}
								if (item[1] != undefined) {
									timeList.push(item[1])
								}
							}
							for (var i = 0, len = timeList.length; i < len; i++) {
								var item = timeList[i]
								if (!isempty(item)) {
									startTag = startTag == 0 ? 1 : 0
								}
								result.push([item, startTag])
							}
						}
						this.dayOptions.series = [{
							name: this.nowVirtualDevice.name,
							type: 'line',
							step: 'end',
							areaStyle: {},
							smooth: false,
							sampling: 'average',
							data: result,
						}]
						this.dayOptions.legend.data = [this.nowVirtualDevice.name]
						this.$refs.dayChart.setData(this.dayOptions, true)
					})
				//获取这个月的运行记录,如果月份没改就不用
				if (this.lastMonth == this.nowSelectDate.formatByMonth()) {
					return
				}
				this.lastMonth = this.nowSelectDate.formatByMonth()
				var monthBg = new Date(this.nowSelectDate.formatByMonth()).getTime()
				var monthDate = new Date(monthBg)
				monthDate.setMonth(monthDate.getMonth() + 1)
				var monthEnd = monthDate.getTime()
				this.$api.lightOldApi.getLightingRangeList(this.nowLightVariable
					.fromName, monthBg, monthEnd, respon => {
						var result = []
						var dataList = []
						if (respon != undefined) {
							dataList = respon[this.nowLightVariable.fromName]
						}
						var startTag = undefined
						for (var start = monthBg; start < monthEnd; start += 24 * 60 * 60 * 1000) {
							var count = 0
							var end = start + 24 * 60 * 60 * 1000
							while (dataList[0] != undefined) {
								var times = dataList[0]
								if (times[0] == undefined) {
									//开始就是开着
									if (times[1] <= end) {
										//今天内关闭
										count += (times[1] - start)
										dataList.shift()
									} else {
										//今天没关
										count += 24 * 60 * 60 * 1000
										break
									}
								} else {
									if (times[0] <= start) {
										//之前就一直开着
										if (times[1] <= end) {
											//今天关了
											count += (times[1] - start)
											dataList.shift()
										} else {
											//今天没关
											count += 24 * 60 * 60 * 1000
											break
										}
									} else if (times[0] > end) {
										//之前关着今天也没开
										break
									} else {
										//之前关着，今天来开了
										if (times[1] <= end) {
											//今天关了
											count += (times[1] - times[0])
											dataList.shift()
										} else {
											//今天没关
											count += (end - times[0])
											break
										}
									}
								}
							}
							result.push([(result.length + 1) + '日', count / (60 * 60 * 1000)])
						}
						this.monthOptions.series = [{
							name: this.nowVirtualDevice.name,
							type: 'bar',
							areaStyle: {},
							smooth: true,
							sampling: 'average',
							data: result,
						}]
						this.monthOptions.legend.data = [this.nowVirtualDevice.name]
						this.$refs.monthChart.setData(this.monthOptions, true)
					})
			},
			control() {
				if (this.nowLightControlVariable == undefined) {
					this.$dialogMethod.showMessage('当前设备不具备遥控功能!')
					return
				}
				this.$api.lightOldApi.openOrCloseVariable(this.nowLightControlVariable.fromName, respon => {
					this.$dialogMethod.showMessage('指令下发成功!')
				}, respon => {
					this.$dialogMethod.showMessage('指令下发失败!')
				})
			}
		}
	}
</script>

<style scoped>
	.archivesBox,
	.controlBox,
	.chartBox {
		border: 1px silver solid;
		width: calc(50% - 22px);
		height: 222px;
		padding: 10px;
		border-radius: 10px;
		background: #eaeaea;
	}

	.archivesBox>div>p:last-child {
		padding-left: 10px;
	}

	.controlBox {
		margin-left: 10px;
	}

	.controlBox>div:first-child {
		width: 180px;
	}

	.controlBox>div:first-child>p {
		padding: 5px 0;
		width: 100%;
	}

	.controlBox>div:first-child>img {
		cursor: pointer;
	}

	.chartBox {
		height: auto;
		width: calc(100% - 30px);
	}
</style>
